module.exports = __webpack_public_path__ + "static/clients_gallery_status@2x-10126536bc91554c8bb49175a03a7102.png";